module.exports = __webpack_public_path__ + "img/courseMan.7d88519f.svg";